import Loader from 'components/loader/Loader';
import {
  IntegrationCategory,
  IntegrationEnum,
} from 'models/InternalIntegrationSetting';
import { Navigate, useParams } from 'react-router-dom';
import useFetchIntegrationAgencySettings from 'hooks/useFetchIntegrationAgencySettings';
import useFeatures from 'hooks/useFeatures';
import { ChannelDetailsWrapper } from './ChannelDetails.styles';
import Breadcrumbs from './components/breadcrumbs/Breadcrumbs';
import Description from './components/Description';
import PropertiesList from './components/propertiesList/PropertiesList';
import useShouldRedirectToChannelsList from './useShouldRedirectToChannelsList';

const ChannelDetails = () => {
  const { id } = useParams();
  const { allowChannelsV3 } = useFeatures();
  const { data: integrationAgencySettings, isLoading } =
    useFetchIntegrationAgencySettings({
      enumId: id as IntegrationEnum,
    });

  const shouldRedirectToChannelsList = useShouldRedirectToChannelsList(
    isLoading,
    integrationAgencySettings,
  );

  const isChannelManager =
    integrationAgencySettings?.integration?.category ===
    IntegrationCategory.CHANNEL_MANAGER;

  const channelName =
    integrationAgencySettings?.integration?.displayName ??
    integrationAgencySettings?.integration?.name;

  if (!allowChannelsV3) {
    return <Navigate to="/channels-migrated" />;
  }

  if (shouldRedirectToChannelsList) {
    return <Navigate to="/channels" />;
  }

  if (isLoading) {
    return <Loader />;
  }

  return (
    <ChannelDetailsWrapper>
      <div>
        <Breadcrumbs
          name={channelName ?? ''}
          logo={integrationAgencySettings?.integration?.logo ?? ''}
          isChannelManager={isChannelManager}
        />
        <Description
          name={channelName ?? ''}
          isChannelManager={isChannelManager}
        />

        {integrationAgencySettings && (
          <PropertiesList
            integrationAgencySettings={integrationAgencySettings}
          />
        )}
      </div>
    </ChannelDetailsWrapper>
  );
};

export default ChannelDetails;
